import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  row: {},
  rowWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  clientsToContactBaseStyle: {
    alignItems: 'center',
  },
});
